<template>

    <DxDrawer>
        <!-- External comments -->
        <div class="cm-section">
            <h3>Comments</h3>
            <div class="tcmScrollView">
                <DxScrollView height="auto"
                              direction="vertical"
                              show-scrollbar="always"
                              scroll-by-content="true"
                              scroll-by-thumb="true">
                    <div class="each_comment">
                        <div class="comment_Field" v-for="cm in externalList" :key="'ext_'+cm.ComId">
                            <div class="comment_owner">
                                <span class="usr_name">{{cm.UsrFullName}}</span>
                                <span class="datum">{{ moment(cm.ComCreatedOn).format('DD.MM.YYYY hh:mm') }}</span>
                                <DxButton v-if="canDelete(cm)" class="delete" styling-mode="text" :width="33" icon="fal fa-trash" @click="deleteComment(cm)" />
                                <DxButton v-if="canEdit(cm)" class="delete" styling-mode="text" :width="33" icon="fal fa-pen" @click="editCommentPopUp(cm)" />
                            </div>
                            <div> "{{cm.ComText}}" </div>
                        </div>
                    </div>
                </DxScrollView>
            </div>
            <div class="text_area" v-if="canCreatePublic">
                <DxTextArea v-model:value="commentTextPublic" :placeholder="hint.ShareYourIdea" />
                <DxButton :width="49" icon="fal fa-paper-plane-top" @click="saveExternalComment()" />
            </div>
        </div>

        <!-- Internal comments (visible with read permission) -->
        <div class="cm-section" v-if="accessList._300581">
            <h3>Change requests</h3>
            <div class="tcmScrollView">
                <DxScrollView height="auto"
                              direction="vertical"
                              show-scrollbar="always"
                              scroll-by-content="true"
                              scroll-by-thumb="true">
                    <div class="each_comment">
                        <div class="comment_Field" v-for="cm in internalList" :key="'int_'+cm.ComId">
                            <div class="comment_owner">
                                <span class="usr_name">{{cm.UsrFullName}}</span>
                                <span class="datum">{{ moment(cm.ComCreatedOn).format('DD.MM.YYYY hh:mm') }}</span>
                                <DxButton v-if="canDelete(cm)" class="delete" styling-mode="text" :width="33" icon="fal fa-trash" @click="deleteComment(cm)" />
                                <DxButton v-if="canEdit(cm)" class="delete" styling-mode="text" :width="33" icon="fal fa-pen" @click="editCommentPopUp(cm)" />
                            </div>
                            <div> "{{cm.ComText}}" </div>
                        </div>
                    </div>
                </DxScrollView>
            </div>
            <div class="text_area" v-if="canCreateInternal">
                <DxTextArea v-model:value="commentTextInternal" :placeholder="hint.ShareYourIdea" />
                <DxButton :width="49" icon="fal fa-paper-plane-top" @click="saveInternalComment()" />
            </div>
        </div>

    </DxDrawer>

    <DxPopup v-model:visible="popupVisible" :title="popupTitle" width="auto" height="auto" :content-template="popupTemplate">
        <template #editComment>
            <div class="puBox">
                <div class="puCell cmtTextBox">
                    <DxTextArea v-model:value="editedCommentText" height="300" width="600" />
                </div>
                <div class="puButtons">
                    <div class="puLeftButtons">
                        <DxButton :text="btn.BtnClose" @click="hidePopup" />
                    </div>
                    <div class="puRightButtons">
                        <DxButton :disabled="editedCommentText=='' " :text="btn.BtnSave" @click="editComment" icon="dx-icon fal fa-paper-plane-top" />
                    </div>
                </div>
            </div>
        </template>
    </DxPopup>
</template>

<script>



    import { DxTextArea } from 'devextreme-vue/text-area';
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import DxButton from 'devextreme-vue/button'
    import DxDrawer from 'devextreme-vue/drawer'
    import { DxPopup } from 'devextreme-vue/popup'
    import { confirm } from "devextreme/ui/dialog";
    import moment from 'moment'
    export default {
        name: 'Voting',
        components: {
            DxButton,
            DxTextArea,
            DxScrollView,
            DxDrawer,
            DxPopup

        },
        props: {
            rtgId: {
                type: [Number],
                required: true,
                default: 0
            },
            topicId: {
                type: [Number],
                required: true,
                default: 0,
                immediate: true,
            },
        },
        data() {
            return {
                popupVisible: false,
                popupTitle: '',
                popupTemplate: '',
                editedCommentText: '',
                comIdToEdit: 0,
                isEditPublic: true,
                commentTextPublic: '',
                commentTextInternal: '',
                currentTopic: null,
                comments: null,
                externalList: [],
                internalList: [],
                hint: {
                    ShareYourIdea: this.$LanguageProvider.GetResource("ShareYourIdea", "PlaceHolder", "Share your opinion..."),


                },
                btn: {
                    BtnClose: this.$LanguageProvider.GetResource("BtnClose", "Caption", "Close"),
                    BtnSave: this.$LanguageProvider.GetResource("BtnSave", "Caption", "Save"),
                },

            }
        },

        computed: {
            currentTopicId() {
                return this.$store.state.applicationStore.currentTopicId
            },
            accessList() {
                return this.$store.state.accessStore.accessList
            },
            canCreatePublic() {
                return !!this.accessList._300514;
            },
            canCreateInternal() {
                return !!this.accessList._300584;
            },
        },
        created: function () {
            this.moment = moment
        },
        mounted: function () {

            // Request tokens used for edit/delete and internal comments, then load comments to avoid race conditions
            this.$store
                .dispatch("getAccessList", { tokenList: ["300231", "300511", "300512", "300514", "300518", "200221", "300561", "300581", "300582", "300584", "300588","300911"] })
                .then(() => {
                    this.showComments();
                });
        },
        watch: {
            topicId: {
                deep: true,
                immediate: true,
                handler() {
                    this.showComments()
                }
            },
            // When access rights arrive (esp. _300581 internal read), refetch to ensure internal comments are loaded
            accessList: {
                deep: true,
                handler(newVal, oldVal) {
                    const prev = oldVal && oldVal._300581;
                    const now = newVal && newVal._300581;
                    if (now && now !== prev) {
                        this.showComments();
                    }
                }
            },

        },
        methods: {
            sanitizeList(list) {
                return (list || []).map(c => ({ ...c, ComText: (c.ComText || '').replace(/<[^>]+>/g, '') }));
            },
            showComments() {
                // External
                this.$store.dispatch("getCommentsForTopic", { TopicId: this.topicId, CtyId: 2 }).then(res => {
                    if (res && res.success) this.externalList = this.sanitizeList(res.comments);
                });
                // Internal (if allowed)
                if (this.accessList._300581) {
                    this.$store.dispatch("getCommentsForTopic", { TopicId: this.topicId, CtyId: 1 }).then(res => {
                        if (res && res.success) this.internalList = this.sanitizeList(res.comments);
                    });
                } else {
                    this.internalList = [];
                }
            },
            saveExternalComment() {
                const text = (this.commentTextPublic || '').replace(/<[^>]+>/g, '');
                if (!text) return;
                this.$store.dispatch("saveTopicComment", { TopicId: this.topicId, Comment: text, CtyId: 2 }).then(() => {
                    this.commentTextPublic = "";
                    this.showComments();
                });
            },
            saveInternalComment() {
                const text = (this.commentTextInternal || '').replace(/<[^>]+>/g, '');
                if (!text) return;
                this.$store.dispatch("saveTopicComment", { TopicId: this.topicId, Comment: text, CtyId: 1 }).then(() => {
                    this.commentTextInternal = "";
                    this.showComments();
                });
            },
            deleteComment(cm) {
                const result = confirm(
                    this.$LanguageProvider?.GetResource("DeleteCmQ", "PlaceHolder", "Are you sure you want to delete this comment?") || "Are you sure you want to delete this comment?",
                    this.$LanguageProvider?.GetResource("ConfirmDelete", "Caption", "Confirm deletion") || "Confirm deletion"
                );
                result.then((dialogResult) => {
                    if (dialogResult) {
                        this.$store.dispatch("deleteComment", { CmId: cm.ComId }).then(() => {
                            this.showComments();
                        })
                    }
                });
            },
            canDelete(cm) {
                const isOwner = cm.IsOwner;
                const isPublic = !!cm.ComIsPublic;
                return isOwner || (isPublic ? !!this.accessList._300518 : !!this.accessList._300588);
            },
            canEdit(cm) {
                const isOwner = cm.IsOwner;
                const isPublic = !!cm.ComIsPublic;
                return isOwner || (isPublic ? !!this.accessList._300512 : !!this.accessList._300582);
            },
            editCommentPopUp(cm) {
                this.popupVisible = true;
                this.popupTemplate = "editComment";
                this.editedCommentText = cm.ComText;
                this.comIdToEdit = cm.ComId;
                this.isEditPublic = !!cm.ComIsPublic;
                this.popupTitle = this.$LanguageProvider?.GetResource("EditComment", "Caption", "Edit Comment") || "Edit Comment";
            },
            editComment() {
                this.$store.dispatch("editComment", { CmId: this.comIdToEdit, Comment: this.editedCommentText }).then(() => {
                    this.showComments();
                    this.editedCommentText = "";
                    this.popupVisible = false;
                })
            },
            hidePopup() {
                this.popupVisible = false
            },


        }
    }

</script>

<style scoped>
    .comment_Field {
        padding: 10px;
        margin-bottom: 10px;
        background-color: #dcf3f7;
        border-radius: 3px;
    }

    .usr_name {
        font-weight: bold;
        color: var(--danger-color);
        background-color: #f2e2eb;
        border-radius: 3px;
        padding: 3px;
    }

    .each_comment {
        max-height: 300px;
    }

    .datum {
        font-size: 10px;
    }

    .comment_owner {
        padding: 5px;
    }

    .text_area {
        display: flex;
        gap: 7px;
        justify-content: space-between;
    }

        .text_area .dx-texteditor {
            width: 100%;
        }

    .tcmScrollView {
        margin-bottom: 10px;
    }
</style>